import React, { useEffect, useState } from "react";
import { Card, Tag, Avatar, Spin,Modal, Upload, Button, Input, message,Form , InputNumber ,Alert ,Progress} from "antd";
import { CameraOutlined,UploadOutlined ,EditOutlined , ExclamationCircleOutlined  } from "@ant-design/icons";
import ImgCrop from "antd-img-crop";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import dayjs from "dayjs";

const ProfileStudent = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const [isPhotoModalOpen, setIsPhotoModalOpen] = useState(false);
const [file, setFile] = useState(null);
const [preview, setPreview] = useState(null);

const [academicEditOpen, setAcademicEditOpen] = useState(false);
const [academicForm] = Form.useForm();

  const token = localStorage.getItem("token");

  const fetchProfile = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/user/instructor/profile/view`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (res.data.success) {
        setProfile(res.data.data);
        localStorage.setItem('profilePhotoUrl',res.data.data.ProfilePhotoUrl)       

      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
  if (profile) {
    academicForm.setFieldsValue({
      College: profile.College,
      Degree: profile.Degree,
      Branch: profile.Branch,
      GraduationYear: profile.GraduationYear,
    });
  }
}, [profile]);


  const handleUpload = async () => {
  if (!file) return message.error("Please select an image");

  const formData = new FormData();
  formData.append("ProfilePhoto", file);

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/user/upload-profile-photo`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (res.data.success) {
      toast.success("Profile photo updated");
      setIsPhotoModalOpen(false);
      setFile(null);
      setPreview(null);
      fetchProfile();
    }
  } catch (err) {
    toast.error("Upload failed");
  }
};

const isAcademicMissing =
  !profile?.College ||
  !profile?.Degree ||
  !profile?.Branch ||
  !profile?.GraduationYear;


  const handleAcademicUpdate = async (values) => {
  try {
    const res = await axios.put(
      `${process.env.REACT_APP_API_URL}/user/student/update-academic`,
      values,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data.success) {
      toast.success("Academic details updated");
      setAcademicEditOpen(false);
      fetchProfile();
    }
  } catch (err) {
    toast.error("Update failed");
  }
};

  if (loading) {
    return (
      <div className="flex justify-center mt-20">
        <Spin size="large" />
      </div>
    );
  }

  if (!profile) return <p>No profile found</p>;

  return (
    <div className="px-6 py-10 mx-auto space-y-6 max-w-7xl">


       <ToastContainer
                          position="bottom-left"
                          autoClose={5000}
                          hideProgressBar={true}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="dark"
                          className="!mb-6 !ml-4"
                          toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                        />

      {/* HEADER */}
     <Card className="p-3 bg-black border-0 rounded-lg shadow-md">

  <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">

    {/* LEFT SECTION */}
    <div className="flex items-center gap-5">

      {/* AVATAR */}
      <div className="relative group">

        <div className="p-[2px]  rounded-full bg-gradient-to-r from-blue-500 to-purple-500">
          <Avatar
            size={90}
            src={profile.ProfilePhotoUrl}
            className="bg-white cursor-pointer "
            onClick={() => setIsPhotoModalOpen(true)}
          >
            {profile.FullName?.[0]}
          </Avatar>
        </div>

        {/* HOVER EDIT */}
        <div
          onClick={() => setIsPhotoModalOpen(true)}
          className="absolute inset-0 flex items-center justify-center transition rounded-full opacity-0 cursor-pointer bg-black/60 group-hover:opacity-100"
        >
          <CameraOutlined className="text-lg text-white" />
        </div>

      </div>

      {/* USER INFO */}
      <div>

        <h1 className="text-2xl font-semibold tracking-tight text-white">
          {profile.FullName}
        </h1>

        <p className="text-sm text-gray-200 mt-0.5">
          {profile.Email}
        </p>

        {/* TAGS */}
        <div className="flex flex-wrap gap-2 mt-3">

          <Tag className="px-3 py-1 text-xs font-medium text-blue-600 border border-blue-100 rounded-md bg-blue-50">
            {profile.Role}
          </Tag>

          <Tag
            className={`px-3 py-1 text-xs font-medium rounded-md border ${
              profile.StudentStatus === "ACTIVE"
                ? "bg-green-50 text-green-600 border-green-100"
                : "bg-red-50 text-red-600 border-red-100"
            }`}
          >
           Student Status : {profile.StudentStatus}
          </Tag>

          <Tag
            className={`px-3 py-1 text-xs font-semibold rounded-md border ${
              profile.PlatformAccess === "ACTIVE"
                ? "bg-purple-50 text-purple-600 border-purple-100"
                : "bg-orange-50 text-orange-600 border-orange-100"
            }`}
          >
           Platform Access : {profile.PlatformAccess}
          </Tag>

        </div>
      </div>

    </div>

    {/* RIGHT SECTION */}
    <div className="flex gap-2">
      <Button
        onClick={() => setIsPhotoModalOpen(true)}
        className="text-white rounded-lg bg-cyan-700 hover:bg-cyan-600"
      >
        Update Photo
      </Button>
    </div>

  </div>

</Card>

      {/* BASIC INFO */}
           <Card
       title={
         <div>
           <h2 className="text-lg font-semibold text-slate-900">
             Basic Information
           </h2>
           <p className="text-xs text-gray-500">
             Your personal contact details
           </p>
         </div>
       }
       className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-orange-50 to-white"
     >
     
       <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
     
         {/* PHONE */}
         <div className="p-4 bg-white border shadow-sm rounded-xl border-sky-100">
           <p className="text-xs font-medium tracking-wide uppercase text-sky-600">
             Phone Number
           </p>
     
           <p className="mt-1 text-sm font-semibold text-slate-800">
             {profile?.PhoneNumber || (
               <span className="text-red-500">Not Provided</span>
             )}
           </p>
         </div>
     
         {/* COUNTRY */}
         <div className="p-4 bg-white border border-blue-100 shadow-sm rounded-xl">
           <p className="text-xs font-medium tracking-wide text-blue-600 uppercase">
             Country
           </p>
     
           <p className="mt-1 text-sm font-semibold text-slate-800">
             {profile?.Country || (
               <span className="text-red-500">Not Provided</span>
             )}
           </p>
         </div>
     
       </div>
     
     </Card>
     
      {/* ACADEMIC DETAILS */}
      <Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Academic Details
      </h2>
      <p className="text-xs text-gray-500">
        Your educational background
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-purple-50 to-white"
  extra={
    <Button
      icon={<EditOutlined />}
      type="text"
      onClick={() => setAcademicEditOpen(true)}
      className="font-medium text-purple-600 rounded-lg hover:bg-purple-100"
    >
      Edit
    </Button>
  }
>

  {/* 🚨 ALERT */}
  {isAcademicMissing && (
    <Alert
      icon={<ExclamationCircleOutlined />}
      message={<span className="font-semibold">Academic Details Required</span>}
      description="Please update your college, degree, branch, and graduation year."
      type="warning"
      showIcon
      className="mb-5 border border-yellow-200 rounded-xl bg-yellow-50"
      action={
        <Button
          size="small"
          type="primary"
          onClick={() => setAcademicEditOpen(true)}
        >
          Update Now
        </Button>
      }
    />
  )}

  {/* CONTENT */}
  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    <div className="p-4 bg-white border rounded-xl">
      <p className="text-xs font-semibold text-purple-600 uppercase">College</p>
      <p className="font-semibold">{profile?.College || <span className="text-red-500">Not Provided</span>}</p>
    </div>

    <div className="p-4 bg-white border rounded-xl">
      <p className="text-xs font-semibold text-indigo-600 uppercase">Degree</p>
      <p className="font-semibold">{profile?.Degree || <span className="text-red-500">Not Provided</span>}</p>
    </div>

    <div className="p-4 bg-white border rounded-xl">
      <p className="text-xs font-semibold text-pink-600 uppercase">Branch</p>
      <p className="font-semibold">{profile?.Branch || <span className="text-red-500">Not Provided</span>}</p>
    </div>

    <div className="p-4 bg-white border rounded-xl">
      <p className="text-xs font-semibold text-orange-600 uppercase">Graduation Year</p>
      <p className="font-semibold">{profile?.GraduationYear || <span className="text-red-500">Not Provided</span>}</p>
    </div>

  </div>

</Card>

      {/* COURSE INFO */}
      <Card
      title={
  <div>
    <h2 className="text-lg font-semibold text-slate-900">
      Course Information
    </h2>
    <p className="text-xs text-gray-500">
      Your enrollment and learning details
    </p>
  </div>
}
      className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-green-50 to-white">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

          <div className="p-4 bg-white border rounded-xl">
            <p className="text-xs font-semibold text-green-600 uppercase">Lead Type</p>
            <p className="font-semibold">{profile.LeadType}</p>
          </div>

          <div className="p-4 bg-white border rounded-xl">
            <p className="text-xs font-semibold uppercase text-emerald-600">Courses Enrolled</p>
            <p className="font-semibold">{profile.CoursesEnrolled || 0}</p>
          </div>

        </div>
      </Card>

     
      {/* TIMELINE */}
   
<Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Activity & Status
      </h2>
      <p className="text-xs text-gray-500">
        Your engagement and interview availability
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-indigo-50 to-white"
>

  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">

    {/* MOCK INTERVIEWS */}
    <div className="p-5 bg-white border border-indigo-100 shadow-sm rounded-xl">
      <p className="text-xs font-semibold tracking-wide text-indigo-600 uppercase">
        Mock Interviews Left
      </p>

      <p className="mt-2 text-3xl font-bold text-slate-900">
        {profile?.MockInterviewsLeft || 0}
      </p>

      <p className="mt-1 text-xs text-gray-500">
        Remaining interview attempts
      </p>
    </div>

    {/* OPTIONAL EXTENSION */}
    <div className="p-5 bg-white border border-purple-100 shadow-sm rounded-xl">
      <p className="text-xs font-semibold tracking-wide text-purple-600 uppercase">
        Account Status
      </p>

      <p className="mt-2 text-lg font-semibold text-slate-800">
        {profile?.PlatformAccess || "Inactive"}
      </p>

      <p className="mt-1 text-xs text-gray-500">
        Current platform access state
      </p>
    </div>

  </div>

</Card>

<Card
  title={
    <div>
      <h2 className="text-lg font-semibold text-slate-900">
        Timeline
      </h2>
      <p className="text-xs text-gray-500">
        Your learning journey and access duration
      </p>
    </div>
  }
  className="p-3 border-0 rounded-lg shadow-sm bg-gradient-to-br from-orange-50 via-white to-orange-50"
>

  <div className="relative pl-8">

    {/* 🔥 TIMELINE LINE */}
    <div className="absolute top-0 bottom-0 left-10 w-[5px] bg-gradient-to-b from-orange-200 to-amber-200" />

    {/* ================= ENROLLED ================= */}
    <div className="relative mb-8">

      {/* DOT */}
      <div className="absolute left-[2px] top-2 w-4 h-4 bg-orange-500 rounded-full border-2 border-white shadow" />

      {/* CARD */}
      <div className="p-5 ml-8 transition bg-white border border-orange-100 shadow-sm rounded-xl hover:shadow-md">

        <div className="flex items-center justify-between">

          <p className="text-xs font-semibold tracking-wide text-orange-600 uppercase">
            Enrolled Date
          </p>

          <span className="px-2 py-1 text-[10px] font-semibold text-orange-700 bg-orange-100 rounded-full">
            START
          </span>

        </div>

        <p className="mt-2 text-base font-semibold text-slate-900">
          {profile?.EnrolledDate
            ? dayjs(profile.EnrolledDate).format("DD MMM YYYY")
            : <span className="text-red-500">Not Available</span>}
        </p>

        <p className="mt-1 text-xs text-gray-500">
          Beginning of your learning journey
        </p>

      </div>
    </div>

    {/* ================= ACCESS ================= */}
    <div className="relative">

      {/* DOT */}
      <div className="absolute left-[2px] top-2 w-4 h-4 bg-amber-500 rounded-full border-2 border-white shadow" />

      {/* CARD */}
      <div className="p-5 ml-8 transition bg-white border shadow-sm border-amber-100 rounded-xl hover:shadow-md">

        <div className="flex items-center justify-between">

          <p className="text-xs font-semibold tracking-wide uppercase text-amber-600">
            Access Expiry
          </p>

          {/* 🔥 STATUS BADGE */}
          <span
            className={`px-2 py-1 text-[10px] font-semibold rounded-full ${
              profile?.PlatformAccessEndDate &&
              dayjs(profile.PlatformAccessEndDate).isAfter(dayjs())
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {profile?.PlatformAccessEndDate &&
            dayjs(profile.PlatformAccessEndDate).isAfter(dayjs())
              ? "ACTIVE"
              : "EXPIRED"}
          </span>

        </div>

        <p className="mt-2 text-base font-semibold text-slate-900">
          {profile?.PlatformAccessEndDate
            ? dayjs(profile.PlatformAccessEndDate).format("DD MMM YYYY")
            : <span className="text-red-500">Not Available</span>}
        </p>

        {/* 🔥 DAYS LEFT */}
        {profile?.PlatformAccessEndDate && (
          <p className="mt-1 text-xs font-medium text-gray-600">
            {dayjs(profile.PlatformAccessEndDate).isAfter(dayjs())
              ? `${dayjs(profile.PlatformAccessEndDate).diff(dayjs(), "day")} days remaining`
              : "Access expired"}
          </p>
        )}

        <p className="mt-1 text-xs text-gray-500">
          Platform access validity period
        </p>

      </div>
    </div>

  </div>

</Card>

      <Modal
  open={isPhotoModalOpen}
  onCancel={() => setIsPhotoModalOpen(false)}
  footer={null}
  centered
  width={500}
 title={
    <span className="text-lg font-semibold text-slate-800">
      Update Profile Photo
    </span>
  }
>

  <div className="space-y-5">

    <div>
      <p className="text-sm text-gray-500">Name</p>
      <Input value={profile.FullName} disabled />
    </div>

    <div>
      <p className="text-sm text-gray-500">Email</p>
      <Input value={profile.Email} disabled />
    </div>

     {/* IMAGE UPLOAD WITH CROP */}
    <div>
      <p className="mb-2 text-sm text-gray-500">
        Upload Profile Photo
      </p>

      <ImgCrop
        rotationSlider
        aspect={1} // square crop
        quality={1}
        modalTitle="Crop Image"
      >
        <Upload
          beforeUpload={(file) => {
            const isImage = file.type.startsWith("image/");
            if (!isImage) {
              message.error("Only image files are allowed");
              return false;
            }

            setFile(file);
            setPreview(URL.createObjectURL(file));
            return false;
          }}
          showUploadList={false}
        >
          <Button icon={<UploadOutlined />} className="w-full h-11">
            Select Image
          </Button>
        </Upload>
      </ImgCrop>

      {/* PREVIEW */}
      {preview && (
        <div className="flex justify-center mt-4">
          <img
            src={preview}
            alt="preview"
            className="object-cover w-32 h-32 border rounded-full"
          />
        </div>
      )}
    </div>
    <Button
      type="primary"
      block
      className="h-11"
      onClick={handleUpload}
    >
      Upload Profile Photo
    </Button>

  </div>

</Modal>

<Modal
  open={academicEditOpen}
  onCancel={() => setAcademicEditOpen(false)}
  footer={null}
  title="Update Educational Details"
  centered
>

  <Form layout="vertical" form={academicForm} onFinish={handleAcademicUpdate}>

    <Form.Item name="College" label="College" rules={[{ required: true }]}>
      <Input />
    </Form.Item>

    <Form.Item name="Degree" label="Degree" rules={[{ required: true }]}>
      <Input />
    </Form.Item>

    <Form.Item name="Branch" label="Branch" rules={[{ required: true }]}>
      <Input />
    </Form.Item>

    <Form.Item
      name="GraduationYear"
      label="Graduation Year"
      rules={[{ required: true }]}
    >
      <Input maxLength={4} />
    </Form.Item>

    <Button type="primary" htmlType="submit" block className="mt-2 h-11">
      Update Educational Details
    </Button>

  </Form>

</Modal>

    </div>
  );
};

export default ProfileStudent;